import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Badge from '@material-ui/core/Badge'

const propTypes = {
  item: PropTypes.object.isRequired,
  addConso: PropTypes.func.isRequired,
  counter: PropTypes.bool,
  size: PropTypes.string
}
class DrinkComponent extends Component {
  state = {
    counter: 0
  }
  static propTypes = {
    item: PropTypes.object.isRequired,
    addConso: PropTypes.func.isRequired,
    counter: PropTypes.bool,
    size: PropTypes.string
  }
  static defaultProps = {
    counter: false,
    size: 'medium'
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.counter && this.props.item !== nextProps.item) {
      this.setState({ counter: 0 })
    }
  }
  handleClick = () => {
    this.props.addConso(null, this.props.item)
    this.setState({ counter: this.state.counter + 1 })
  }
  render() {
    const { item, size } = this.props
    const label = item.name + ' - ' + Number(item.price).toFixed(2) + ' €'
    const buttonStyle = {
      borderRadius: 5,
      backgroundColor: item.color,
      color: 'white'
    }
    return this.props.counter && this.state.counter > 0 ? (
      <Badge color="primary" badgeContent={this.state.counter}>
        <Button
          style={buttonStyle}
          size={size}
          variant="raised"
          onClick={this.handleClick}>
          {label}
        </Button>
      </Badge>
    ) : (
      <Button
        style={buttonStyle}
        size={size}
        variant="raised"
        onClick={this.handleClick}>
        {label}
      </Button>
    )
  }
}

DrinkComponent.propTypes = propTypes
export default DrinkComponent



// WEBPACK FOOTER //
// ./src/routes/Products/components/DrinkComponent.js